import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-913135e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sponsors-and-partners",
  id: "SponsorsAndPartners"
}
const _hoisted_2 = { class: "sponsors-and-partners__block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sponsors-and-partners__small-title sponsors-and-partners__looks-rare" }, " Looks rare ", -1))
const _hoisted_4 = { class: "sponsors-and-partners__looks-rare-icons" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sponsors-and-partners__separation-line" }, null, -1))
const _hoisted_8 = { class: "sponsors-and-partners__block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sponsors-and-partners__small-title sponsors-and-partners__title-few" }, " Few ", -1))
const _hoisted_10 = { class: "sponsors-and-partners__few-icons" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sponsors-and-partners__separation-line" }, null, -1))
const _hoisted_14 = { class: "sponsors-and-partners__block" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sponsors-and-partners__small-title sponsors-and-partners__title-few sponsors-and-partners__black-white-filter" }, " Frens ", -1))
const _hoisted_16 = { class: "sponsors-and-partners__friends-icons sponsors-and-partners__frens" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sponsors-and-partners__separation-line" }, null, -1))
const _hoisted_20 = { class: "sponsors-and-partners__block" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sponsors-and-partners__small-title sponsors-and-partners__title-few" }, " Media ", -1))
const _hoisted_22 = { class: "sponsors-and-partners__others-icons sponsors-and-partners__media" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["src", "alt"]

import SectionTitle from "@/components/SectionTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsorsAndPartners',
  setup(__props) {

const looksRare = [
  { name: "pwn", link: "https://pwn.finance/", image: "pwn.svg",},
  { name: "uniswap", link: "https://uniswap.org/", image: "uniswap.svg",},
  { name: "moralis", link: "https://moralis.io/", image: "moralis.svg",},
];
const few = [
  { name: "wallet-connect", link: "https://walletconnect.com/", image: "wallet-connect.svg"},
  { name: "eth-foundation", link: "https://ethereum.foundation", image: "eth-foundation.svg"},
  { name: "livepeer", link: "https://livepeer.org/", image: "livepeer.svg"},
  { name: "ledger", link: "https://www.ledger.com/", image: "ledger.svg"},
  { name: "element", link: "https://www.element.fi/", image: "element.png"},
  { name: "galaxis", link: "https://galaxis.xyz/#/", image: "galaxis.svg" },
];

const friends = [
  { name: "boba-network", link: "https://simon@boba.network/", image: "boba-network.png" },
  { name: "chainsafe", link: "https://chainsafe.io/", image: "chainsafe.svg" },
  { name: "starkware", link: "https://starkware.co/", image:  "starkware.svg" },
  { name: "wintermute", link: "https://www.wintermute.com/", image:  "wintermute.svg" },
  { name: "golem-foundation", link: "https://golem.foundation/", image:  "golem-foundation.png" },
  { name: "ethswarm", link: "https://ethswarm.org/", image:  "ethswarm.svg" },
  { name: "connext", link: "https://connext.network/", image:  "connext.svg" },
  { name: "openq", link: "https://www.openq.dev/", image:  "openq.png" },
  { name: "nodereal", link: "https://nodereal.io/", image:  "nodereal.svg" },
];

const partners = [
  { name: "rekt", link: "https://rekt.news/", image: "rekt.png" },
  { name: "BanklessDAO", link: "https://www.bankless.community/", image: "bankless.png" },
  { name: "WindingTree", link: "https://windingtree.com/", image: "windingtree.png" },
  { name: "Serotonin", link: "https://serotonin.co/", image: "serotonin.png" }
]

const getSponsorsOrPartnersImage = (imageName: string) => {
  return require(`../assets/sponsors-and-partners/${imageName}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SectionTitle, { title: "sponsors & partners" }),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(looksRare, (company) => {
          return _createElementVNode("a", {
            key: company.name,
            href: company.link,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: getSponsorsOrPartnersImage(company.image),
              alt: company.name,
              class: "sponsors-and-partners__looks-rare-icon"
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_5)
        }), 64))
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(few, (company) => {
          return _createElementVNode("a", {
            key: company.name,
            href: company.link,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: getSponsorsOrPartnersImage(company.image),
              alt: company.name,
              class: "sponsors-and-partners__few-icon"
            }, null, 8, _hoisted_12)
          ], 8, _hoisted_11)
        }), 64))
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(friends, (company) => {
          return _createElementVNode("a", {
            key: company.name,
            href: company.link,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: getSponsorsOrPartnersImage(company.image),
              alt: company.name,
              class: "sponsors-and-partners__few-icon"
            }, null, 8, _hoisted_18)
          ], 8, _hoisted_17)
        }), 64))
      ])
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(partners, (company) => {
          return _createElementVNode("a", {
            key: company.name,
            href: company.link,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: getSponsorsOrPartnersImage(company.image),
              alt: company.name,
              class: "sponsors-and-partners__friends-icon"
            }, null, 8, _hoisted_24)
          ], 8, _hoisted_23)
        }), 64))
      ])
    ])
  ]))
}
}

})